import script from "./ConceptoAccionesMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./ConceptoAccionesMenu.vue?vue&type=script&setup=true&lang=js"

import "./ConceptoAccionesMenu.vue?vue&type=style&index=0&id=258a883e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-258a883e"]])

export default __exports__